(function (e, t) {
  typeof exports == "object" && typeof module < "u" ? module.exports = t(require("@hotwired/stimulus")) : typeof define == "function" && define.amd ? define(["@hotwired/stimulus"], t) : (e = typeof globalThis < "u" ? globalThis : e || self, e.StimulusCharacterCounter = t(e.Stimulus));
})(this, function (e) {
  "use strict";

  class t extends e.Controller {
    initialize() {
      this.update = this.update.bind(this);
    }
    connect() {
      this.update(), this.inputTarget.addEventListener("input", this.update);
    }
    disconnect() {
      this.inputTarget.removeEventListener("input", this.update);
    }
    update() {
      this.counterTarget.innerHTML = this.count.toString();
    }
    get count() {
      let n = this.inputTarget.value.length;
      return this.hasCountdownValue && (this.maxLength < 0 && console.error(`[stimulus-character-counter] You need to add a maxlength attribute on the input to use countdown mode. The current value is: ${this.maxLength}.`), n = Math.max(this.maxLength - n, 0)), n;
    }
    get maxLength() {
      return this.inputTarget.maxLength;
    }
  }
  return t.targets = ["input", "counter"], t.values = {
    countdown: Boolean
  }, t;
});